import React from 'react';
import { motion } from 'framer-motion';
import styles from './HeroHeader.module.css';

interface HeroHeaderProps {
    title: string;
    subtitle: string;
}

const HeroHeader: React.FC<HeroHeaderProps> = ({ title, subtitle }) => {
    return (
        <motion.div
            className={styles.heroContainer}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2 }}
        >
            <div className={styles.heroBackground} />
            <div className={styles.heroContent}>
                <motion.div
                    className={styles.textSection}
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3, duration: 1, ease: [0.16, 1, 0.3, 1] }}
                >
                    <h1 className={styles.title}>{title}</h1>
                    <p className={styles.subtitle}>{subtitle}</p>
                    <div className={styles.divider} />
                </motion.div>
            </div>
        </motion.div>
    );
};

export default HeroHeader;
